import { whatsappConfigService } from "@/_services";

export const whatsappConfig = {
  namespaced: true,
  state: {
    configInfo: {
      data: null,
      status: {},
    },
    updateConfig: {
      data: null,
      status: {},
    },
  },
  mutations: {
    getWhatsappConfigRequest(state) {
      state.configInfo.status = {
        loading: true,
      };
    },
    getWhatsappConfigError(state, error) {
      state.configInfo.data = null;
      state.configInfo.status = {
        error,
      };
    },
    getWhatsappConfigSuccess(state, config) {
      state.configInfo.data = config;
      state.configInfo.status = {
        loaded: true,
      };
    },
    updateWhatsappConfigRequest(state) {
      state.updateConfig.status = {
        updating: true,
      };
    },
    updateWhatsappConfigError(state, error) {
      state.updateConfig.data = null;
      state.updateConfig.status = {
        error,
      };
    },
    updateWhatsappConfigSuccess(state, config) {
      state.updateConfig.data = config;
      state.updateConfig.status = {
        updated: true,
      };
    },
  },
  actions: {
    getWhatsappConfig({ commit }, franquiciaId) {
      commit("getWhatsappConfigRequest");
      whatsappConfigService
        .getWhatsappConfig(franquiciaId)
        .then((config) => {
          commit("getWhatsappConfigSuccess", config);
        })
        .catch((error) => {
          commit("getWhatsappConfigError", error);
        });
    },
    updateWhatsappConfig({ commit }, { franquiciaId, body }) {
      commit("updateWhatsappConfigRequest");
      whatsappConfigService
        .updateWhatsappConfig(franquiciaId, body)
        .then((config) => {
          commit("updateWhatsappConfigSuccess", config);
        })
        .catch((error) => {
          commit("updateWhatsappConfigError", error);
        });
    },
  },
};
